import ModalLayout from 'components/modal/modal-layout/ModalLayout';
import styles from './AddRoles.module.scss';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import addRoles from 'services/team/addRoles';
import { useTeamContext } from 'contexts/group-practice-context/TeamContext';
import getRolesForTeam, { Role } from 'services/team/getRoles';
import removeRoleFromTeam from 'services/team/removeRoleFromTeam';
import Loading from 'components/Loading';

const AddRoles = ({ show, onClose, setSuccessMsg, setError }) => {
  // TODO: Uncomment the commented code to add custom roles feature
  // const [showCustomInput, setShowCustomInput] = useState(false);
  const [roles, setRoles] = useState<string[]>([]);
  const [existingRoles, setExistingRoles] = useState<Role[]>([]);
  const [formData, setFormData] = useState({
    role_name: '',
    // customRole: '',
  });
  const [loading, setLoading] = useState(true);
  const { currentTeam } = useTeamContext();

  const handleSubmit = async e => {
    e.preventDefault();
    if (!currentTeam || !formData.role_name) return;
    try {
      await addRoles(currentTeam.id, formData);
      setSuccessMsg('Role added successfully');
    } catch (err) {
      setError(err);
    }
    onClose();
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // if (name === 'role') {
    //   setShowCustomInput(value === 'CUSTOM');
    //   if (value !== 'CUSTOM') {
    //     setFormData(prev => ({ ...prev, customRole: '' }));
    //   }
    // }
  };

  const handleDeleteRole = async (roleId: number, teamId: number) => {
    if (!teamId) return;
    try {
      await removeRoleFromTeam(teamId, roleId);
      setSuccessMsg('Role deleted successfully');
    } catch (err) {
      console.error(err);
    }
    onClose();
  };

  const formatRole = (role: string) => {
    return role
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  useEffect(() => {
    if (!currentTeam) return;
    const fetchExistingRoles = async () => {
      try {
        const roles = await getRolesForTeam(currentTeam.id);
        setExistingRoles(roles);
        setLoading(false);
      } catch (err) {
        setError(err);
      }
    };
    fetchExistingRoles();
  }, [setError, currentTeam]);

  // TODO: Create a getRolesToAddToTeam utility function in services/team to fetch roles from backend
  useEffect(() => {
    if (!currentTeam) return;
    const fetchRoles = async () => {
      try {
        // const response = await getRolesToAddToTeam(currentTeam.id);
        // const rolesArr = response.filter(role => role !== 'OWNER');
        const rolesArr = ['PRACTICE_SCHEDULER'];
        const availableRoles = rolesArr.filter(
          roleName => !existingRoles.some(er => er.name === roleName),
        );
        setRoles(availableRoles);
      } catch (error) {
        setError('Error fetching roles:', error);
      }
    };
    fetchRoles();
  }, [currentTeam, setError, existingRoles]);

  return (
    <ModalLayout
      show={show}
      onHide={onClose}
      size='lg'
      showHeaderDivider
      Header='Add Roles'
      headerClass={styles['roles-editor__header']}
      bodyClass={styles['roles-editor__body']}
      dialogClassName={styles['roles-editor__dialog']}
    >
      {loading ? (
        <Loading />
      ) : (
        <Modal.Body>
          {existingRoles.length > 0 && (
            <div>
              <h6 className='mb-3'>Existing Roles</h6>
              <Row className={styles['roles-editor__role-row']}>
                {existingRoles.map(({ name, id: roleId }) => (
                  <Col
                    md={6}
                    className={`${styles['roles-editor__role-name']} mb-2`}
                    key={roleId}
                  >
                    <div className='d-flex justify-content-between align-items-center border rounded p-2'>
                      <span>{formatRole(name)}</span>
                      {name !== 'OWNER' && (
                        <Button
                          variant='outline-danger'
                          className={styles['roles-editor__delete-btn']}
                          onClick={() =>
                            handleDeleteRole(
                              Number(roleId),
                              Number(currentTeam?.id),
                            )
                          }
                        >
                          Delete
                        </Button>
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          )}
          <Form onSubmit={e => handleSubmit(e)}>
            {/* {showCustomInput && (
            <Form.Group controlId='formCustomRole' className='mt-3'>
              <Form.Label className={styles['roles-editor__label']}>
                Custom Role Name<span className='required'>*</span>
              </Form.Label>
              <Form.Control
                required
                type='text'
                name='customRole'
                value={formData.customRole}
                onChange={handleChange}
                placeholder='Enter custom role name'
                className={styles['roles-editor__form-control']}
              />
            </Form.Group>
          )} */}
            <Form.Group controlId='formRole'>
              <Form.Label className={styles['roles-editor__label']}>
                Role<span className='required'>*</span>
              </Form.Label>
              <Form.Control
                required
                as='select'
                name='role_name'
                value={formData.role_name}
                onChange={handleChange}
                className={styles['member-editor__form-control']}
              >
                <option value=''>Select a role</option>
                {/* <option value='CUSTOM'>Custom Role</option> */}
                {roles.map(role => (
                  <option key={role} value={role}>
                    {formatRole(role)}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Modal.Footer>
              <Button variant='secondary' onClick={onClose}>
                Cancel
              </Button>
              <Button variant='primary' type='submit'>
                Add Role
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      )}
    </ModalLayout>
  );
};

export default AddRoles;
